import axios from "axios";
import apiConfig from "@/apiConfig";
import { Message } from "element-ui";


const CancelToken = axios.CancelToken;
let source: any = CancelToken.source();

function instance(options: any) {

    return new Promise((resolve, reject) => {
        const instanced = axios.create({
            headers: {
                "Cache-Control": "no-cache"
            },
            timeout: 30 * 1000,
            cancelToken: source.token
        });
        instanced.defaults.baseURL = apiConfig.baseUrl;

        // 添加响应拦截器
        instanced(options).then(
            (response: any) => {
                // if (response.data.head.respCode === "0000005") {
                //     source.cancel("接口异常，进程终止！");
                //     setTimeout(() => {
                //         source = CancelToken.source();
                //     }, 200);
                //     return reject();//失败终止请求
                // }
                resolve(response.data);//成功返回数据
            },
            (error: any) => {
                if (error.code === "ECONNABORTED") {
                    source.cancel("网络异常，进程终止！");
                    setTimeout(() => {
                        source = CancelToken.source();
                    }, 200);
                    Message.warning("网络异常，请稍后再试！");
                }
                reject(error);
            }
        );
    });
    // instanced.interceptors.response.use();
}

export default class AxiosConfig {
    /**
     * @description get 请求
     * @param url 请求地址
     * @param data 参数
     */
    axiosGet(url: string  , data?: any) {
        if (data) {
            data.timeStampForCache = new Date().getTime();
        } else {
            data = {
                timeStampForCache: new Date().getTime()
            };
        }
        return instance({
            method: "get",
            url,
            params: data
        });
    }

    /**
     * @description post 请求
     * @param url 请求地址
     * @param data 参数
     * @param isJson 是否为 json 格式，默认 form 表单格式
     */
    axiosPost(url: string, data?: any, isJson: boolean = false, headers: object = {}) {
        if (isJson) {
            return instance({
                method: "post",
                url,
                data,
                headers
            });
        } else {
            return instance({
                method: "post",
                url,
                params: data
            });
        }
    }

    /**
     * @description put 请求
     * @param url 请求地址
     * @param data 参数
     * @param isJson 是否为 json 格式，默认 form 表单格式
     */
    axiosPut(url: string, data?: any, isJson: boolean = false) {
        if (isJson) {
            return instance({
                method: "put",
                url,
                data
            });
        } else {
            return instance({
                method: "put",
                url,
                params: data
            });
        }
    }

    /**
     * @description delete 请求
     * @param url 请求地址
     * @param data 参数
     * @param isJson 是否为 json 格式，默认 form 表单格式
     */
    axiosDelete(url: string, data?: any, isJson: boolean = false) {
        if (isJson) {
            return instance({
                method: "delete",
                url,
                data
            });
        } else {
            return instance({
                method: "delete",
                url,
                params: data
            });
        }
    }
}
